import { useState } from "react";
import settings from "../../../constants/settings";
import useTriggerSounds from "../sounds";
import useFetchAndTrace from "../fetchWithTrace";

interface BarcodesRequest {
  barcode: string;
  check_barcode_exists: boolean;
}

export function usePrintBarcode(
  onError?: (detail: string) => void,
  checkBarcodeExists: boolean = false,
  resetBarcode?: () => void,
) {
  const { triggerGoodSound, triggerBadSound } = useTriggerSounds();
  const fetchAndTrace = useFetchAndTrace();
  const [loading, setLoading] = useState<boolean>(false);

  const errorHandler = () => {
    setLoading(false);
    onError?.("Failed to create barcode");
  };

  const handleCreateBarcode = async (response: Response) => {
    setLoading(false);
    if (response.ok) {
      const blob = await response.blob();
      const link = document.createElement("a");
      link.download = "FPCB_barcode.pdf";
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.click();
      window.open(objectUrl);
      resetBarcode?.();
      triggerGoodSound();
    } else if (response.status === 400) {
      triggerBadSound();
      const { detail } = (await response.json()) as { detail: string };
      onError?.(detail);
    } else {
      throw Error("Failed to create barcode");
    }
  };

  const createBarcode = (barcode: string) => {
    if (!barcode) {
      triggerBadSound();
    } else {
      setLoading(true);
      void fetchAndTrace(
        `${settings.api_url}/inventory/barcode-pdf`,
        handleCreateBarcode,
        errorHandler,
        {
          body: JSON.stringify({
            barcode,
            check_barcode_exists: checkBarcodeExists,
          } as BarcodesRequest),
          method: "PUT",
        },
      );
    }
  };

  return {
    isLoading: loading,
    createBarcode,
  };
}
